<template>
  <div class="error-block">
    <div class="chat-item chat-item--question">
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ message }}
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import functionsMixin from '../../mixins/functionsMixin'

export default {
  name: 'FormError',
  mixins: [functionsMixin],
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.error-block {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/FormError.vue